export const FETCH_DATA_REQUEST_CART = "FETCH_DATA_REQUEST_CART";
export const FETCH_DATA_SUCCESS_CART = "FETCH_DATA_SUCCESS_CART";
export const FETCH_DATA_FAILURE_CART = "FETCH_DATA_FAILURE_CART";
export const REMOVE_ITEM_CART = "REMOVE_ITEM_CART";
export const UPDATE_ITEM_CART = "UPDATE_ITEM_CART";
export const CLEAR_ALL_CART = "CLEAR_ALL_CART";
export const APPLY_COUPON = "APPLY_COUPON";
export const CLEAR_ACCOUNT = "CLEAR_ACCOUNT";